import React from 'react';
import { observer } from 'mobx-react-lite';
import { Timer } from '../../stores/timer-store';
import { timerStore } from '../../stores/timer-store';
import './timer-card.scss';

interface TimerCardProps {
  timer: Timer;
}

export const TimerCard: React.FC<TimerCardProps> = observer(({ timer }) => {
  const handleStart = () => {
    timerStore.startTimer(timer.id);
  };

  const handlePause = () => {
    timerStore.pauseTimer(timer.id);
  };

  const handleReset = () => {
    timerStore.resetTimer(timer.id);
  };

  const handleDelete = () => {
    timerStore.deleteTimer(timer.id);
  };

  const progress = timer.duration > 0 ? ((timer.duration - timer.remaining) / timer.duration) * 100 : 0;

  return (
    <div className={`timer-card ${timer.isCompleted ? 'timer-card--completed' : ''}`}>
      <div className="timer-card__header">
        <h3 className="timer-card__name">{timer.name}</h3>
        <button 
          onClick={handleDelete}
          className="timer-card__delete"
          title="Delete timer"
        >
          ✕
        </button>
      </div>

      <div className="timer-card__display">
        <div className="timer-card__time">
          {timerStore.formatTime(timer.remaining)}
        </div>
        <div className="timer-card__progress">
          <div 
            className="timer-card__progress-bar"
            style={{ width: `${progress}%` }}
          />
        </div>
        <div className="timer-card__duration">
          / {timerStore.formatTime(timer.duration)}
        </div>
      </div>

      <div className="timer-card__controls">
        {!timer.isRunning && !timer.isCompleted && (
          <button 
            onClick={handleStart}
            className="timer-card__button timer-card__button--start"
            disabled={timer.remaining <= 0}
          >
            {timer.isPaused ? 'Resume' : 'Start'}
          </button>
        )}
        
        {timer.isRunning && (
          <button 
            onClick={handlePause}
            className="timer-card__button timer-card__button--pause"
          >
            Pause
          </button>
        )}

        <button 
          onClick={handleReset}
          className="timer-card__button timer-card__button--reset"
        >
          Reset
        </button>
      </div>

      {timer.isCompleted && (
        <div className="timer-card__completed">
          ⏰ Timer completed!
        </div>
      )}
    </div>
  );
});
